import { useConfiguratorContext } from "@/hooks/configurator/configurator-context";
import { ConfiguratorSectionProps } from "../RenderCustomComponent";
import { Option } from "@/hooks/configurator/types";
import { useStudio } from "@/hooks/useStudio";
import { cn } from "@/lib/utils";
import { HelpCircle, X, AlertTriangle } from "lucide-react";

export function PaintSelection(props: ConfiguratorSectionProps) {
  const studio = useStudio();
  const configurator = useConfiguratorContext();

  const handleSelect = (option: Option) => {
    configurator.toggleOption(props.section.id, option.id);

    if ((window as any).environment === "colorful") {
      studio.viewer.setBackgroundColor(option.metadata?.uiColor);
    }
    // studio.viewer.setBackgroundColor(option.metadata?.uiColor);
  };

  return (
    <div className="w-full">
      <div className="w-full grid grid-cols-2">
        {configurator.getAvailableOptions(props.section.id).map((option) => (
          <div
            key={option.id}
            className="w-full flex flex-col items-center gap-2 py-2"
          >
            <div
              className={cn(
                "relative p-0.5 justify-center border-2 border-white rounded-full w-18 h-18  hover:scale-105 hover:border-2  hover:border-gray-300 transition-all duration-300 cursor-pointer",
                configurator.isOptionSelected(option.id) &&
                  "border-2 border-black"
              )}
              onClick={() => handleSelect(option)}
            >
              <div className="relative overflow-hidden rounded-full w-full h-full">
                <svg
                  className="absolute inset-0 w-full h-full pointer-events-none"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ zIndex: 2 }}
                >
                  <clipPath id={`circle-clip`}>
                    <circle cx="28" cy="28" r="28" />
                  </clipPath>

                  {option?.metadata?.uiSecondaryColor && (
                    <g clipPath="url(#circle-clip)">
                      <polygon
                        points="56,56 20,56 56,20"
                        fill={option.metadata?.uiSecondaryColor}
                      />
                    </g>
                  )}
                </svg>
                <div
                  className="rounded-full w-full h-full"
                  style={{ backgroundColor: option.metadata?.uiColor }}
                />
              </div>
            </div>

            <div className="text-sm text-gray-500">{option.label}</div>
            {/* <button
              onClick={(e) => {
                e.stopPropagation();
                // setActiveModal(combo.name);
              }}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <HelpCircle className="w-4 h-4" />
            </button> */}
          </div>
        ))}
      </div>
    </div>
  );
}
